import { render, staticRenderFns } from "./AllInactiveFactures.vue?vue&type=template&id=240959be&"
import script from "./AllInactiveFactures.vue?vue&type=script&lang=js&"
export * from "./AllInactiveFactures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports